import * as React from 'react';
import classnames from 'classnames';
import { H4 } from '@grandvisionhq/iris-ui';
import { DonationSummary } from '@grandvisionhq/lib-visuals';
import { useIntl } from '@grandvisionhq/state';
import { formatPrice } from '@grandvisionhq/utils';
import { useCart } from '../../context/Cart/context.js';
import '@swc/helpers';
import '@grandvisionhq/common';
import '@grandvisionhq/graphql';
import '@grandvisionhq/svc-tealium/events';
import '../../models/add-to-cart/add-to-cart.js';
import '../../models/cart/cart.js';
import '../../models/subscription/subscription-details.js';
import '../../models/checkoutState/checkoutState.js';
import '../../utils/cart-count-var.js';
import '../../utils/cart-id-var.js';
import '@grandvisionhq/commercetools';
import '../../utils/get-unrecoverable-validation-errors.js';
import '../../models/line-item/prescription-glasses.js';
import '../../utils/get-failure-error-codes.js';
import '../../utils/get-validation-errors-by-line-item.js';
import '../../operations/fragments/cart-details.js';
import '../../operations/fragments/cart-validation-errors.js';
import '../../operations/fragments/recover-inactive-cart-failure.js';
import '../../operations/fragments/recover-inactive-cart-result.js';
import '../../operations/mutations/add-cart-line-items.js';
import '../../operations/mutations/add-cart-voucher-codes.js';
import '../../operations/mutations/create-cart.js';
import '../../operations/mutations/create-cart-from-instant-checkout-link.js';
import '../../operations/mutations/create-cart-from-order.js';
import '../../operations/mutations/duplicate-cart-line-items.js';
import '../../operations/mutations/remove-cart-voucher-codes.js';
import '../../operations/mutations/remove-cart-line-items.js';
import '../../operations/mutations/update-cart-line-items.js';
import '../../operations/mutations/replace-line-item-contact-lenses-bundle-benelux.js';
import '../../operations/mutations/recover-inactive-cart.js';
import '../../operations/queries/get-cart.js';
import '../../operations/queries/get-total-line-items.js';
import '../../operations/queries/get-cart-estimated-delivery.js';
import '../../context/CartSettings/context.js';
import { TotalsContainer } from '../Totals/containers/TotalsContainer.js';
import '@grandvisionhq/elements';
import { NavigationContainer } from './components/navigation/NavigationContainer.js';

const Summary = ({ isReadOnly , summaryLabel , donationAmount , hasSubscription , unavailableLineItems , handleCheckoutNavigation  })=>{
    const { locale , currency , getLabel , getFormattedLabel  } = useIntl();
    const { cart  } = useCart();
    var _totalPrice;
    return /*#__PURE__*/ React.createElement("section", {
        className: classnames('cart-summary', {
            'cart-summary--read-only': isReadOnly
        })
    }, /*#__PURE__*/ React.createElement(H4, {
        className: "cart-summary__heading",
        variant: "heading-smallest",
        "aria-hidden": isReadOnly ? 'true' : undefined
    }, summaryLabel), /*#__PURE__*/ React.createElement(TotalsContainer, null), donationAmount && /*#__PURE__*/ React.createElement(DonationSummary, {
        label: getLabel('checkout.payment.donation.summary.title'),
        formattedDonationAmount: formatPrice({
            locale,
            value: donationAmount,
            currency,
            isCentAmount: true
        }),
        disclaimer: getFormattedLabel('checkout.payment.donation.summary.description', {
            labelData: {
                total: formatPrice({
                    locale,
                    value: ((_totalPrice = cart === null || cart === void 0 ? void 0 : cart.prices.totalPrice) !== null && _totalPrice !== void 0 ? _totalPrice : 0) + donationAmount,
                    currency,
                    isCentAmount: true
                }),
                cartTotal: formatPrice({
                    locale,
                    value: cart === null || cart === void 0 ? void 0 : cart.prices.totalPrice,
                    currency,
                    isCentAmount: true
                }),
                donationTotal: formatPrice({
                    locale,
                    value: donationAmount,
                    currency,
                    isCentAmount: true
                })
            }
        })
    }), !isReadOnly && /*#__PURE__*/ React.createElement("div", {
        className: "cart-summary__navigation"
    }, /*#__PURE__*/ React.createElement(NavigationContainer, {
        handleCheckoutNavigation: handleCheckoutNavigation,
        hasSubscription: hasSubscription,
        unavailableLineItems: unavailableLineItems
    })));
};

export { Summary };
//# sourceMappingURL=Summary.js.map
